import { PropsWithChildren, ReactElement } from "react";
import styles from "./InputWithSpecialSyntax.module.less";
import { FontIconName, Icon } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { useInfoPlaceHoldersDialog } from "./InfoPlaceHoldersDialog";

export type SpecialSyntaxKind = "placholder" | "expression";

export type InputWithSpecialSyntaxProps = {
	kind: SpecialSyntaxKind;
};

export const InputWithSpecialSyntax = (props: PropsWithChildren<InputWithSpecialSyntaxProps>): ReactElement => {
	const {
		kind,
		children
	} = props;

	const { icon, tooltipKey } = kindToConfigurationMap[kind];

	const [infoPlaceHoldersDialog, openInfoPlaceHoldersDialog] = useInfoPlaceHoldersDialog();

	return (
		<>
			<div className={styles.root}>
				<div className={styles.input}>
					{children}
				</div>
				<div
					className={styles.icon}
					role="button"
					onClick={() => openInfoPlaceHoldersDialog({})}
				>
					<Icon
						value={{
							kind: "font",
							name: icon,
							color: "secondary"
						}}
						size="large"
						tooltip={localize(tooltipKey)}
					/>
				</div>
			</div>
			{infoPlaceHoldersDialog}
		</>
	);
};
InputWithSpecialSyntax.displayName = "InputWithSpecialSyntax";

type SyntaxConfiguration = {
	icon: FontIconName;
	tooltipKey: LocalizationKey;
};

const kindToConfigurationMap: Record<SpecialSyntaxKind, SyntaxConfiguration> = {
	placholder: {
		icon: "brackets-curly",
		tooltipKey: "_IntegrationBuilderPlaceholderFieldTooltip"
	},
	expression: {
		icon: "function",
		tooltipKey: "_IntegrationBuilderExpressionFieldTooltip"
	}
};
